import React from "react";
import { Link } from "react-router-dom";
import services from "../../api/services";

interface GallerySectionProps {
  currentSlug: string;
}

const GallerySection: React.FC<GallerySectionProps> = ({ currentSlug }) => {
  const others = services.filter((s) => s.slug !== currentSlug);

  return (
    <div className="mt-100 mb-60">
      <h2 className="details-content-title mb-45">Other Services</h2>
      <div className="row mt-none-30">
        {others.map((service) => (
          <div className="col-lg-4 col-sm-6 mt-30" key={service.id}>
            <Link
              to={`/service/${service.slug}`}
              style={{ textDecoration: "none" }}
            >
              <div
                style={{
                  border: "1px solid #eee",
                  borderRadius: 12,
                  padding: "32px 24px",
                  textAlign: "center",
                  background: "#fff",
                  transition: "box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLDivElement).style.boxShadow =
                    "0 8px 32px rgba(0,0,0,0.10)";
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLDivElement).style.boxShadow = "none";
                }}
              >
                <img
                  src={service.logo}
                  alt={service.title}
                  style={{
                    width: 64,
                    height: 64,
                    objectFit: "contain",
                    marginBottom: 16,
                  }}
                />
                <h4
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#1a1a1a",
                    marginBottom: 8,
                  }}
                >
                  {service.title}
                </h4>
                <p
                  style={{
                    fontSize: 14,
                    color: "#666",
                    lineHeight: 1.5,
                    margin: 0,
                  }}
                >
                  {service.shortDesc}
                </p>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GallerySection;
